import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Separator from "@components/CustomTypography/Separator/Separator"
import Title from "@components/CustomTypography/Title/Title"
import ContentAssetSwitcher from "@components/WebsiteRevamp/Switchers/ContentAssetSwitcher/ContentAssetSwitcher"
import {AdvancedSideAssetModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import WorkshpoCardsSection from "./WorkshopCards/WorkshpoCardsSection"

type Props = {
	data: AdvancedSideAssetModuleType[]
}

const ExpertiseWorkshop = (props: Props) => {
	return (
		<section id={"workshop"}>
			<Separator size={128}>
				<ContainerWrapper>
					<Title
						content={props.data[0].sectionTitle}
						size={"XL"}
						center
					/>
					<WorkshpoCardsSection data={props.data[0]} />
					<Separator />
					<ContentAssetSwitcher
						data={props.data[1]}
						contentAssetProps={{
							withAspectRation: true,
						}}
						separatorSize={128}
					/>
				</ContainerWrapper>
			</Separator>
		</section>
	)
}

export default ExpertiseWorkshop
